module.exports = __webpack_public_path__ + "assets/img/contractcomparsion-app2.cd96dca3.png";